module.exports = __webpack_public_path__ + "static/media/DSCF0006.a2436271.jpg";